import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { FILTER_MESSAGES, FiltersMessages } from "../inputs/filters.messages";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "../tables/columns.messages";

export type SkuMovementMessages = ActionButtonMessages &
  TableColumnsMessages &
  FiltersMessages & {
    // Titles
    stockMovementTitle: string;
    stockMovementHistoryTitle: string;

    // Labels
    typeLabel: string;
    quantityLabel: string;
    commentsLabel: string;
    entryOption: string;
    exitOption: string;
    movementDateLabel: string;
    initialDateLabel: string;
    finalDateLabel: string;

    // Error messages
    errorRequiredType: string;
    errorRequiredQuantity: string;
    errorQuantityGreaterThanZero: string;
    errorRequiredComments: string;

    // Success and error messages for stock creation
    successCreateStockMessage: string;
    errorCreateStockMessage: string;

    // No data message
    noDataMessage: string;
  };

export const SKU_MOVEMENT_MESSAGES: SkuMovementMessages = {
  // Titles
  stockMovementTitle: "Movimentação de Estoque",
  stockMovementHistoryTitle: "Histórico de Movimentação de Estoque",

  // Labels
  typeLabel: "Tipo",
  quantityLabel: "Quantidade",
  commentsLabel: "Observação",
  entryOption: "Entrada",
  exitOption: "Saída",
  movementDateLabel: "Data",
  initialDateLabel: "Data Inicial",
  finalDateLabel: "Data Final",

  // Error messages
  errorRequiredType: "O tipo é obrigatório!",
  errorRequiredQuantity: "A quantidade é obrigatória!",
  errorQuantityGreaterThanZero: "A quantidade deve ser maior que zero!",
  errorRequiredComments: "Comentários são obrigatórios",

  // Success and error messages for stock creation
  successCreateStockMessage: "Estoque criado com sucesso!",
  errorCreateStockMessage: "Erro ao criar o estoque.",

  // No data message
  noDataMessage: "Nenhum dado disponível para os filtros aplicados.",

  // Action button messages
  ...TABLE_COLUMNS_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...FILTER_MESSAGES,
};
